import { gql } from '@apollo/client'

export const getCollections = gql`
  {
    collections(first: 250) {
      collectionList: nodes {
        id
        title
        description
        descriptionHtml
        handle
        seo{
          title
          description
        }
        image {
          url
        }
      }
    }
  }
`
export const customerActivateByUrl = gql`
  mutation customerActivateByUrl($password: String!, $activationUrl: URL!) {
    customerActivateByUrl(password: $password, activationUrl: $activationUrl) {
      customerAccessToken {
        accessToken
        expiresAt
      }
      customer {
        email
      }
    }
  }
`;

export const createCustomer = gql`
  mutation customerCreate($input: CustomerCreateInput!) {
    customerCreate(input: $input) {
      customerUserErrors {
        code
        field
        message
      }
      customer {
        id
        email
        firstName
        lastName
        phone
      }
    }
  }
`

export const getProductOnCollection = gql`
  query (
    $categoryId: ID
    $sortKey: ProductCollectionSortKeys
    $reverse: Boolean = true
  ) {
    collection(id: $categoryId) {
      products(first: 250, reverse: $reverse, sortKey: $sortKey) {
        edges {
          node {
            id
            handle
            title
            description
            tags
            productType
            priceRange {
              maxVariantPrice {
                amount
              }
              minVariantPrice {
                amount
              }
            }
            images(first: 50) {
              nodes {
                id
                url
              }
            }
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
`

export const getProductOnCollectionByHandle = gql`
  query (
    $handle: String!
    $sortKey: ProductCollectionSortKeys
    $reverse: Boolean = true
  ) {
    collection(handle: $handle) {
      products(first: 250, reverse: $reverse, sortKey: $sortKey) {
        edges {
          node {
            id
            handle
            title
            description
            productType
            priceRange {
              maxVariantPrice {
                amount
              }
              minVariantPrice {
                amount
              }
            }
            images(first: 50) {
              nodes {
                id
                url
              }
            }
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
`

export const getProductOnCollectionPaging = gql`
  query ($categoryId: ID, $cursor: String) {
    collection(id: $categoryId) {
      products(first: 20, reverse: true, after: $cursor) {
        edges {
          node {
            id
            title
            description
            priceRange {
              maxVariantPrice {
                amount
              }
              minVariantPrice {
                amount
              }
            }
            images(first: 50) {
              nodes {
                id
                url
              }
            }
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
`

export const getProductDetails = gql`
  query ($id: ID) {
    product(id: $id) {
      id
      handle
      title
      description
      descriptionHtml
      collections(first: 50) {
        edges {
          node {
            title
          }
        }
      }
      productType
      variants(first: 100) {
        edges {
          node {
            id
            title
            selectedOptions {
              name
              value
            }
            priceV2 {
              amount
            }
            compareAtPriceV2 {
              amount
            }
            image {
              url
            }
          }
        }
      }
      images(first: 50) {
        nodes {
          id
          url
        }
      }
    }
  }
`

export const getProductPrice = gql`
query @inContext(country: FR) {
  localization {
    availableCountries {
      currency {
        isoCode
        name
        symbol
      }
    }
  }
}
`


export const getProductDetailsWithHandle = gql`
  query ($handle: String!) {
    product(handle: $handle) {
      id
      handle
      title
      totalInventory
      description
      descriptionHtml
      tags
      seo {
        title
        description
      }
      collections(first: 50) {
        edges {
          node {
            title
          }
        }
      }
      productType
      variants(first: 100) {
        edges {
          node {
            id
            title
            selectedOptions {
              name
              value
            }
            priceV2 {
              amount
            }
            compareAtPriceV2 {
              amount
            }
            image {
              url
            }
          }
        }
      }
      images(first: 50) {
        nodes {
          id
          url
        }
      }
    }
  }
`

export const searchProducts = gql`
  query ($search: String) {
    products(first: 40, query: $search, sortKey: TITLE) {
      edges {
        node {
          id
          title
          handle
        }
      }
    }
  }
`

export const getBlogsList = gql`
  {
    articles(first: 6, reverse: true) {
      edges {
        node {
          id
          title
          handle
          content
          contentHtml
          publishedAt
          tags
          author {
            name
          }
          image {
            url
          }
        }
      }
      pageInfo {
        hasNextPage
        endCursor
        hasPreviousPage
        startCursor
      }
    }
  }
`
export const getBlogPrevious = gql`
  query ($cursor: String) {
    articles(last: 20, reverse: true, before: $cursor) {
      edges {
        node {
          id
          title
          handle
          content
          contentHtml
          image {
            url
          }
        }
      }
      pageInfo {
        hasNextPage
        endCursor
        hasPreviousPage
        startCursor
      }
    }
  }
`

export const getBlogsListPaging = gql`
  query ($cursor: String) {
    articles(first: 6, reverse: true, after: $cursor) {
      edges {
        node {
          id
          title
          handle
          content
          contentHtml
          image {
            url
          }
        }
      }
      pageInfo {
        hasNextPage
        endCursor
        hasPreviousPage
        startCursor
      }
    }
  }
`
export const getProducts = gql`
  query ($search: String, $sortKey: ProductSortKeys) {
    products(first: 20, query: $search, sortKey: $sortKey, reverse: true) {
      edges {
        node {
          id
          handle
          title
          description
          descriptionHtml
          tags
          priceRange {
            maxVariantPrice {
              amount
            }
            minVariantPrice {
              amount
            }
          }
          images(first: 50) {
            nodes {
              id
              url
            }
          }
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`

export const getCustomerAccessTokenQuery = gql`
  mutation customerAccessTokenCreate($input: CustomerAccessTokenCreateInput!) {
    customerAccessTokenCreate(input: $input) {
      customerUserErrors {
        code
        field
        message
      }
      customerAccessToken {
        accessToken
        expiresAt
      }
    }
  }
`

export const forgotPasswordQuery = gql`
  mutation customerRecover($email: String!) {
    customerRecover(email: $email) {
      customerUserErrors {
        code
        field
        message
      }
    }
  }
`

export const createCartQuery = gql`
  mutation ($input: CartInput!) {
    cartCreate(input: $input) {
      cart {
        id
        createdAt
        updatedAt
        lines(first: 250) {
          edges {
            node {
              id
              quantity
              merchandise {
                ... on ProductVariant {
                  id
                  title
                  priceV2 {
                    amount
                  }
                  image {
                    url
                  }
                }
              }
            }
          }
        }
        cost {
          totalAmount {
            amount
            currencyCode
          }
          subtotalAmount {
            amount
            currencyCode
          }
          totalTaxAmount {
            amount
            currencyCode
          }
          totalDutyAmount {
            amount
            currencyCode
          }
        }
      }
    }
  }
`

export const getCustomerQuery = gql`
  query ($token: String!) {
    customer(customerAccessToken: $token) {
      id
      email
      firstName
      lastName
      phone
      defaultAddress {
        address1
              address2
              city
              company
              country
              countryCodeV2
              firstName
              lastName
              name
              phone
              province
              provinceCode
              zip
      }
    }
  }
`

export const addItemToCartQuery = gql`
  mutation cartLinesAdd($cartId: ID!, $lines: [CartLineInput!]!) {
    cartLinesAdd(cartId: $cartId, lines: $lines) {
      cart {
        id
        createdAt
        updatedAt
        lines(first: 250) {
          edges {
            node {
              id
              quantity
              merchandise {
                ... on ProductVariant {
                  id
                  title
                  product {
                    description
                    title
                  }
                  priceV2 {
                    amount
                  }
                  image {
                    url
                  }
                }
              }
            }
          }
        }
        cost {
          totalAmount {
            amount
            currencyCode
          }
          subtotalAmount {
            amount
            currencyCode
          }
          totalTaxAmount {
            amount
            currencyCode
          }
          totalDutyAmount {
            amount
            currencyCode
          }
        }
      }
    }
  }
`

export const getCheckoutUrlQuery = gql`
  query ($id: ID!) {
    cart(id: $id) {
      checkoutUrl
    }
  }
`

export const getCartQuery = gql`
query ($id: ID!) {
  cart(id: $id) {
    id
    createdAt
    updatedAt
    lines(first: 250) {
      edges {
        node {
          id
          quantity
          merchandise {
            ... on ProductVariant {
              id
              title
              image {
                url
              }
              product {
                description
                title
              }
              priceV2 {
                amount
              }
              image {
                url
              }
            }
          }
          discountAllocations {
            discountedAmount {
              amount
            }
          }
        }
      }
    }
    cost {
      totalAmount {
        amount
        currencyCode
      }
      subtotalAmount {
        amount
        currencyCode
      }
      totalTaxAmount {
        amount
        currencyCode
      }
      totalDutyAmount {
        amount
        currencyCode
      }
    }
  }
}
`

export const removeItemFromCart = gql`
  mutation cartLinesRemove($cartId: ID!, $lineIds: [ID!]!) {
    cartLinesRemove(cartId: $cartId, lineIds: $lineIds) {
      cart {
        id
        lines(first: 250) {
          edges {
            node {
              id
              quantity
              merchandise {
                ... on ProductVariant {
                  id
                }
              }
            }
          }
        }
      }
      userErrors {
        field
        message
      }
    }
  }
`

export const updateCartQuery = gql`
  mutation cartLinesUpdate($cartId: ID!, $lines: [CartLineUpdateInput!]!) {
    cartLinesUpdate(cartId: $cartId, lines: $lines) {
      cart {
        id
        createdAt
        updatedAt
        lines(first: 250) {
          edges {
            node {
              id
              quantity
              merchandise {
                ... on ProductVariant {
                  id
                  title
                  product {
                    description
                    title
                  }
                  priceV2 {
                    amount
                  }
                  image {
                    url
                  }
                }
              }
            }
          }
        }
        cost {
          totalAmount {
            amount
            currencyCode
          }
          subtotalAmount {
            amount
            currencyCode
          }
          totalTaxAmount {
            amount
            currencyCode
          }
          totalDutyAmount {
            amount
            currencyCode
          }
        }
      }
    }
  }
`

export const logoutCustomerQuery = gql`
  mutation customerAccessTokenDelete($customerAccessToken: String!) {
    customerAccessTokenDelete(customerAccessToken: $customerAccessToken) {
      deletedAccessToken
      deletedCustomerAccessTokenId
      userErrors {
        field
        message
      }
    }
  }
`

export const getOrderListQuery = gql`
  query ($token: String!) {
    customer(customerAccessToken: $token) {
      orders(first: 100, reverse: true) {
        edges {
          node {
            id
            orderNumber
            canceledAt
            fulfillmentStatus
            totalPriceV2 {
              amount
            }
            currentTotalPrice {
              amount
            }
            processedAt
            lineItems(first: 100) {
              edges {
                node {
                  currentQuantity
                  quantity
                  originalTotalPrice {
                    amount
                  }
                  variant {
                    id
                    title
                    image {
                      url
                    }
                    priceV2 {
                      amount
                    }
                    unitPrice {
                      amount
                    }
                    product {
                      id
                      title
                      collections(first: 10) {
                        edges {
                          node {
                            title
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
            metafield(key: "shipment_id", namespace: "custom") {
              key
              namespace
              value
            }
            successfulFulfillments {
              trackingInfo {
                number
                url
              }
            }
            statusUrl
            shippingAddress {
              address1
              address2
              city
              company
              country
              countryCodeV2
              firstName
              lastName
              name
              phone
              province
              provinceCode
              zip
            }

            billingAddress {
              address1
              address2
              city
              company
              country
              countryCodeV2
              firstName
              lastName
              name
              phone
              province
              provinceCode
              zip
            }
          }
        }

        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
`

export const resetPasswordQuery = gql`
  mutation resetPasswordByUrl($resetUrl: URL!, $password: String!) {
    customerResetByUrl(resetUrl: $resetUrl, password: $password) {
      customer {
        id
      }
      customerUserErrors {
        code
        field
        message
      }
    }
  }
`

export const checkUserDetail = gql`
  query ($token: String!) {
    customer(customerAccessToken: $token) {
      id
    }
  }
`

export const currencyCheck = gql`
  query @inContext(country: INR) {
    products(first: 1) {
      edges {
        node {
          variants(first: 1) {
            edges {
              node {
                price {
                  amount
                  currencyCode
                }
              }
            }
          }
        }
      }
    }
  }
`



export const getBlogBySlug = gql`
  query getBlogBySlug($slug: String!) {
    articles(query: $slug, first: 1) {
      nodes {
        id
        title
        publishedAt
        tags
        author {
          name
        }
        image {
          url
        }
        content
        contentHtml
      }
    }
  }
`;

